import { CLEAR_CONVERSION_FACTORS, CONVERSION_FACTORS_LOADING, FETCH_CONVERSION_FACTORS } from './actions'
import { getConversionFactors } from '@/apis/conversionFactorAPI'
import { IConversionFactor } from '@/utils/types/model/conversionFactor'

export interface ConversionFactorState {
  conversionFactors: IConversionFactor[]
  totalRecords: number
  loading: boolean
}

const conversion = {
  state: (): ConversionFactorState => ({
    conversionFactors: [],
    totalRecords: 0,
    loading: false,
  }),

  mutations: {
    [CONVERSION_FACTORS_LOADING](state: ConversionFactorState, payload: boolean) {
      state.loading = payload
    },

    [FETCH_CONVERSION_FACTORS](
      state: ConversionFactorState,
      payload: { conversionFactors: IConversionFactor[]; totalRecords: number }
    ) {
      state.conversionFactors = payload.conversionFactors
      state.totalRecords = payload.totalRecords
    },

    [CLEAR_CONVERSION_FACTORS](state: ConversionFactorState) {
      state.conversionFactors = []
      state.totalRecords = 0
    },
  },

  actions: {
    async [FETCH_CONVERSION_FACTORS](
      { commit }: { commit: Function },
      { page, limit, itemCode }: { page: number; limit: number; itemCode: string }
    ) {
      commit(CONVERSION_FACTORS_LOADING, true)

      try {
        const res = await getConversionFactors(page, limit, itemCode)
        commit(FETCH_CONVERSION_FACTORS, {
          conversionFactors: res.conversionFactors,
          totalRecords: res.totalRecords,
        })
      } catch (err) {
        commit(CLEAR_CONVERSION_FACTORS)
        throw err
      } finally {
        commit(CONVERSION_FACTORS_LOADING, false)
      }
    },
  },

  getters: {
    conversionFactors: (state: ConversionFactorState) => state.conversionFactors,
    conversionTotalRecords: (state: ConversionFactorState) => state.totalRecords,
    conversionLoading: (state: ConversionFactorState) => state.loading,
  },
}

export default conversion
